// extracted by mini-css-extract-plugin
export default {"link":"subscription-page_link__vhhZJ","bgNoSub":"subscription-page_bgNoSub__y5Ppg"};